<template>
  <div class="sidebar-item-container">
    <router-link :to="url">
      <div class="sidebar-item">
        <div class="sidebar-item__icon-container">
          <span class="sidebar-item__icon">
            <slot name="icon"></slot>
          </span>
        </div>
        <div class="sidebar-item__title">
          <p>{{ title }}</p>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  // props: ["title", "url"],
  props: {
    title: String,
    url: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
a {
  color: #9bbbe2;
  font-weight: normal;
}
a:hover {
  text-decoration: none;
}

.router-link-exact-active p {
  color: #ffffff;
}

.router-link-active > .sidebar-item {
  background: rgba(255, 255, 255, 0.3);
}
.sidebar-item {
  display: flex;
  height: 100%;
  align-items: center;
  /* margin-bottom: 1.2rem; */
  padding: 0.6rem 1rem;
}
.sidebar-item__icon-container {
  display: flex;
  height: 100%;
  align-items: center;
}
.sidebar-item__icon {
  margin-right: 1rem;
}
</style>
